import { FaLongArrowAltDown as LongArrowDown } from 'react-icons/fa';

export default LongArrowDown;
